module.exports = __webpack_public_path__ + "img/sys1-select.16c4558c.png";